/* global */

import React from 'react';
import styled, { ThemeProvider } from 'styled-components';

import theme from '../../../../theme';

import { DialogBody } from '../../../components/DialogBody';
import { DialogFooter } from '../../../components/DialogFooter';
import Table from '../../../components/Table';

const Button = styled.button.attrs({
    type: 'button'
})`
    margin-left: 4px;
`;

const ListCont = styled.div`
    margin-top: 2rem;
    padding: 1rem 0.5rem;
`;

export const SpecGridInfoModal = ({ ...props }) => {
    const columns = React.useMemo(
        () => [
            {
                Header: `Notation`,
                accessor: `notation`,
                disableSortBy: true,
                filterable: false,
                Cell: ({ cell }) => {
                    return (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}
                        >
                            <span>{cell?.row?.original?.name ?? ''}</span>
                            <span>"{cell?.row?.original?.notation ?? ''}"</span>
                        </div>
                    );
                }
            },
            {
                Header: `Description`,
                accessor: `description`,
                disableSortBy: true,
                filterable: false
            }
        ],
        []
    );
    const tableData = React.useMemo(
        () => [
            {
                name: 'Sufficient',
                notation: 'S',
                description: (
                    <span style={{ whiteSpace: 'wrap', alignSelf: 'flex-start' }}>
                        Presence of this criterion alone indicates sufficient requirement for reporting.
                    </span>
                ),
                DataTableActions: null
            },
            {
                name: 'Necessary',
                notation: 'N',
                description: (
                    <span style={{ whiteSpace: 'wrap' }}>
                        Presence of this criterion with other criteria (either <i>Necessary</i> or <i>Optional</i> ) is
                        needed to meet the requirement for reporting.
                    </span>
                ),
                DataTableActions: null
            },
            {
                name: 'Optional',
                notation: 'O',
                description: (
                    <span style={{ whiteSpace: 'wrap' }}>
                        Presence of one or more <i>Optional</i> criteria within a category paired with a{' '}
                        <i>Necessary</i> is needed to meet the requirement for reporting.
                    </span>
                ),
                DataTableActions: null
            }
        ],
        []
    );

    return (
        <ThemeProvider theme={theme}>
            <div
                id="spec-grid-info-modal-el"
                className={`modal-dialog modal-lg`}
                aria-modal="true"
                aria-labelledby="spec-grid-info-modal-title"
                style={{
                    maxWidth: '900px'
                }}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 className="modal-title">
                            <span id="spec-grid-info-modal-title">
                                Additional Information about Criteria and Logic Sets
                            </span>
                        </h4>
                    </div>
                    <DialogBody style={{ paddingBottom: 0 }}>
                        <p style={{ marginBottom: '1rem', padding: '0 0.5rem' }}>
                            The reporting rules indicate the following:
                        </p>
                        <Table
                            columns={columns}
                            data={tableData}
                            fullWidth={false}
                            withActions={false}
                            withHeader={false}
                            id={'criteria-notation-table'}
                            label={''}
                            loading={false}
                            showControlDeck={false}
                            paginated={false}
                        />
                        <ListCont>
                            In order to be Operable, the Logic Set must meet one of the following scenarios:
                            <ul>
                                <li>
                                    There are one or more active and implemented <i>Sufficient</i> criteria{' '}
                                    <strong>OR</strong>
                                </li>
                                <li>
                                    If there are no <i>Optional</i> criteria, all active <i>Necessary</i> criteria are
                                    implemented (minimum of 2) <strong>OR</strong>
                                </li>
                                <li>
                                    All active <i>Necessary</i> criteria are implemented (minimum of 1) and, from every
                                    category where Optionals are present, there is one or more active and implemented{' '}
                                    <i>Optional</i> criteria
                                </li>
                            </ul>
                        </ListCont>
                        <p>
                            For more information, see the{' '}
                            <a
                                href={`${props.contextPath}/assets/RCKMS%20Authoring%20Tool%20Jurisdiction%20User%20Guide.pdf`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                RCKMS User Guide
                            </a>
                        </p>
                    </DialogBody>
                    <DialogFooter>
                        <Button className="btn btn-default" data-dismiss="modal">
                            Close
                        </Button>
                    </DialogFooter>
                </div>
            </div>
        </ThemeProvider>
    );
};

SpecGridInfoModal.propTypes = {};

export default SpecGridInfoModal;
